import { CoreMenu } from "@core/types";
import { BehaviorSubject } from "rxjs";
import { Users } from "../main/pages/_sommavi/models/Users";
import { RoleName } from "../main/pages/_sommavi/models/roles";

//-> CAS DE ROLES EN TABLEAUX
// function isAuthorized(roles) {
//   let currentUserSubject = new BehaviorSubject<Users>(JSON.parse(sessionStorage.getItem('currentUser')));
//   if (currentUserSubject.value!==null) {
//     let curentUserRoles = currentUserSubject.value.roles;
//     for(let role of curentUserRoles) {
//       if (roles.indexOf(role.nom) > -1) return true;
//     }
//   }
//
//   return false;
// }

function isAuthorized2(roles) {
  let currentUserSubject = new BehaviorSubject<Users>(
    JSON.parse(sessionStorage.getItem("currentUser"))
  );
  if (currentUserSubject.value !== null) {
    if (roles.indexOf(currentUserSubject.value.roles.nom) > -1) return true;
  }
  return false;
}


function hasPermission(permissions) {
  let currentUserSubject = new BehaviorSubject<Users>(JSON.parse(sessionStorage.getItem('currentUser')));
  if (currentUserSubject.value!==null) {
    let curentUserPermissions = currentUserSubject.value.permissions;
    for(let permission of curentUserPermissions) {
      if (permissions.indexOf(permission.access) > -1) return true;
    }
  }

  return false;
}


//-> LE MENU EST CONSTRUIT A LA DEMANDE (CONNEXION, DECONNEXION, MISE A JOUR DES DROITS) : hasPermission LIT LA SESSION COURANTE
export function construireMenu(): CoreMenu[] {
  return [
  {
    id: "apps",
    type: "section",
    title: "Dashboard",
    icon: "pie-chart",
    hidden: !hasPermission(["AFFICHE_STATISTIQUES"]),
    children: [
      // {
      //   id: "home",
      //   title: "Info structure",
      //   type: "item",
      //   icon: "home",
      //   url: "pages/gestions/info-structure",
      //   // hidden: !hasPermission(["LISTE_STRUCTURE"]),
      // },
      {
        id: "analytics",
        title: "Statistiques",
        type: "item",
        // role: ["Admin"], //? To set multiple role: ['Admin', 'Client']
        icon: "bar-chart-2",
        url: "pages/analytics/statistiques",
        hidden: !hasPermission(["AFFICHE_STATISTIQUES"]),

      },
      // {
      //   id: "analytics_produits",
      //   title: "Stat Articles",
      //   type: "item",
      //   icon: "bar-chart-2",
      //   url: "pages/statistiques/articles",
      // },
      // {
      //   id: "analytics_vendeurs", //... ok
      //   title: "Stat Vendeurs",
      //   type: "item",
      //   icon: "bar-chart-2",
      //   url: "pages/statistiques/vendeurs",
      // },
      // {
      //   id: "analytics_vendeurs", // .... ok
      //   title: "Stat Chiffres",
      //   type: "item",
      //   icon: "bar-chart-2",
      //   url: "pages/statistiques/chiffres",
      // },
    ],
  },

  {
    id: "apps",
    type: "section",
    title: "Structure",
    icon: "cpu",
    hidden: !hasPermission(["STRUCTURE_INFO"]),

    children: [
      {
        id: "home",
        title: "Info structure",
        type: "item",
        icon: "home",
        url: "pages/gestions/info-structure",
        hidden: !hasPermission(["STRUCTURE_INFO"]),
      },
      // {
      //   id: "utilisateurs_new",
      //   title: "Info Structure",
      //   type: "item",
      //   icon: "user",
      //   url: "pages/gestions/utilisateurs",
      //   hidden: !hasPermission(["LISTE_USER"]),
      // },
    ]
  },

  {
    id: "apps",
    type: "section",
    title: "Gestions",
    icon: "cpu",
    hidden: !hasPermission(["LISTE_USER","LISTE_CLIENTS", "LISTE_EMPLACEMENTS", "LISTE_SOUS_EMPLACEMENTS","LISTE_REMISE_REGLE", "LISTE_REMISE_VENDEUR"]),

    children: [
      // GESTION
      {
        id: "utilisateurs_new",
        title: "Utilisateurs",
        type: "item",
        icon: "user",
        url: "pages/gestions/utilisateurs",
        hidden: !hasPermission(["LISTE_USER"]),
      },
      {
        id: "assurance_new",
        title: "Assurances",
        type: "item",
        icon: "users",
        url: "pages/gestions/assurances",
        hidden: !hasPermission(["LISTE_ASSURANCES"]),

      },
      {
        id: "clients_new",
        title: "Clients",
        type: "item",
        icon: "users",
        url: "pages/gestions/clients",
        hidden: !hasPermission(["LISTE_CLIENTS"]),

      },
      {
        id: "fournisseurs_new",
        title: "Fournisseurs",
        type: "item",
        icon: "users",
        url: "pages/gestions/fournisseurs",
        hidden: !hasPermission(["LISTE_FOURNISSEURS"]), //todo: add LISTE_FOURNISSEURS

      },
      {
        id: "emplacement_new",
        title: "Emplacements",
        type: "item",
        icon: "map-pin",
        url: "pages/gestions/emplacements",
        hidden: !hasPermission(["LISTE_EMPLACEMENTS", "LISTE_SOUS_EMPLACEMENTS"]),

      },
      {
        id: "remise_new",
        title: "Remises",
        type: "item",
        icon: "minus-circle",
        url: "pages/gestions/remises",
        hidden: !hasPermission(["LISTE_REMISE_REGLE", "LISTE_REMISE_VENDEUR"]),
      },
    ],
  },

  {
    id: "article_produit_new",
    type: "section",
    title: "Articles(Produit)",
    icon: "package",
    hidden: !hasPermission(["LISTE_CATEGORIES","LISTE_DONNEES_ARTICLES","LISTE_ARTICLES"]),

    children: [
      // {
      //   id: "categories_new",
      //   title: "Catégorie d'article",
      //   type: "item",
      //   icon: "octagon",
      //   url: "pages/gestions-articles/categories",
      //   hidden: !hasPermission(["LISTE_CATEGORIES"]),
      // },
      // {
      //   id: "donnees-produits_new",
      //   title: "Données des articles",
      //   type: "item",
      //   icon: "file-text",
      //   url: "pages/gestions-articles/donnees-produits",
      //   hidden: !hasPermission(["LISTE_DONNEES_ARTICLES"]),

      // },

      // {
      //   id: "article_new",
      //   title: "Article",
      //   type: "item",
      //   icon: "hexagon", //slack
      //   url: "pages/gestions-articles/articles",
      //   hidden: !hasPermission(["LISTE_ARTICLES"]),

      // },
      {
        id: "article_verres",
        title: "Verres",
        type: "item",
        icon: "hexagon", //slack
        url: "pages/gestions-articles/verres",
        hidden: !hasPermission(["LISTE_ARTICLES"]),
      },
      {
        id: "article_lentilles",
        title: "Lentilles",
        type: "item",
        icon: "hexagon", //slack
        url: "pages/gestions-articles/lentilles",
        hidden: !hasPermission(["LISTE_ARTICLES"]),
      },
      {
        id: "article_montures",
        title: "Montures",
        type: "item",
        icon: "hexagon", //slack
        url: "pages/gestions-articles/montures",
        hidden: !hasPermission(["LISTE_ARTICLES"]),

      },
      {
        id: "article_accessoires",
        title: "Accessoires",
        type: "item",
        icon: "hexagon", //slack
        url: "pages/gestions-articles/accessoires",
        hidden: !hasPermission(["LISTE_ARTICLES"]),

      }
    ],
  },
  {
    id: "apps",
    type: "section",
    title: "Ventes",
    icon: "check-square",
    hidden: !hasPermission(["LISTE_COMMANDES", "LISTE_PAIEMENT_ECHELONNE"]),

    children: [
      // GESTION
      {
        id: "commande_new_client",
        title: "Commande",
        type: "item",
        icon: "twitch",
        url: "pages/gestions-ventes/commande",
        hidden: !hasPermission(["LISTE_COMMANDES"]),

      },
      {
        id: "Payement_echelone_new_client",
        title: "Payement des commandes",
        type: "item",
        icon: "dollar-sign",
        url: "pages/gestions-ventes/paiement-clients",
        //-> LA PAGE GERE LES PAIEMENTS ECHELONNES (L'ENCAISSEMENT SIMPLE SE FAIT DEPUIS LA LISTE DES COMMANDES)
        hidden: !hasPermission(["LISTE_PAIEMENT_ECHELONNE"]),

      },
    ],
  },

  //-->  STOCKS
  {
    id: "apps",
    type: "section",
    title: "Stock",
    icon: "archive",
    hidden: !hasPermission(["DO_RAVITAILLEMENTS","SUIVI_STOCK","VALIDER_SORTIE_STOCK"]),
    children: [
      // STOCK
      {
        id: "ravitaillement_new",
        title: "Ravitaillement",
        type: "item",
        icon: "truck",
        url: "pages/gestions-stocks/ravitaillement",
        hidden: !hasPermission(["DO_RAVITAILLEMENTS"]),
      },
      {
        id: "suivie_new",
        title: "Suivi du stock",
        type: "item",
        icon: "activity",
        url: "pages/gestions-stocks/suivi-stock",
        hidden: !hasPermission(["SUIVI_STOCK"]) || !isAuthorized2([RoleName.ROLE_ADMIN, RoleName.ROLE_STOCK_MANAGER]),
      },
      {
        id: "sortie_new",
        title: "Sortie de stock",
        type: "item",
        icon: "check",
        url: "pages/gestions-stocks/sortie-stock",
        hidden: !hasPermission(["VALIDER_SORTIE_STOCK"]),

      },
    ],
  },
  //-->  INVENTAIRES
  {
    id: "apps",
    type: "section",
    title: "Inventaire",
    icon: "list",
    hidden: !hasPermission(["LISTE_INVENTAIRES","SAISIE_INVENTAIRES"]),

    children: [
      // GESTION
      {
        id: "fichier_new",
        title: "fichier d’inventaire",
        type: "item",
        icon: "clipboard",
        url: "pages/gestions-stocks/inventaire",
        hidden: !hasPermission(["LISTE_INVENTAIRES"]),

      },
      // {
      //   id: "saisie__new",
      //   title: "Saisie quantités",
      //   type: "item",
      //   icon: "clipboard",
      //   url: "pages/gestions-stocks/inventaire-saisie",
      //   hidden: !hasPermission(["SAISIE_INVENTAIRES"]),

      // },
      {
        id: "ma_saisie_plage_new",
        title: "Ma saisie (plages)",
        type: "item",
        icon: "edit-3",
        url: "pages/gestions-stocks/inventaire-ma-saisie",
        hidden: !hasPermission(["SAISIE_INVENTAIRES"]),

      },
    
    ],
  },

  {
    id: "apps",
    type: "section",
    title: "Comptabilité",
    icon: "dollar-sign",
    hidden: !hasPermission(["LISTE_VERSEMENTS"]),

    children: [
      // GESTION
      {
        id: "compta_suivie_versement",
        title: "Versements",
        type: "item",
        icon: "eye",
        url: "pages/gestions-comptabilite/versement",
        hidden: !hasPermission(["LISTE_VERSEMENTS"]),

      },
      // {
      //   hidden: true,
      //   id: "compta_impay",
      //   title: "Impayés",
      //   type: "item",
      //   icon: "rotate-ccw",
      //   url: "pages/gestions-comptabilite/impaye",
      // },
    ],
  },
  // {
  //   id: 'apps',
  //   type: 'section',
  //   title: 'Volet',
  //   icon: 'package',
  //   children: [
  //     // GESTION
  //     {
  //       id: 'gestion_new',
  //       title: 'Gestion',
  //       type: 'item',
  //       icon: 'settings',
  //       url: 'pages/gestions/gestion'
  //     },

  //     // STOCK
  //     {
  //       id: 'stock',
  //       title: 'Stocks',
  //       type: 'item',
  //       icon: 'archive',
  //       url: 'pages/gestions-stocks/stocks'
  //     },

  //     // VENTES
  //     {
  //       id: 'vente',
  //       title: 'Ventes',
  //       type: 'item',
  //       icon: 'plus-circle',
  //       url: 'pages/gestions-ventes/ventes'
  //     },

  //     // ACHATS
  //     {
  //       id: 'achats',
  //       title: 'Achats',
  //       type: 'item',
  //       icon: 'shopping-cart',
  //       url: 'pages/gestions-achats/achats'
  //     },
  //   ]
  // },

  // {
  //   id: 'settings',
  //   title: 'Paramètres',
  //   type: 'collapsible',
  //   icon: 'settings',
  //   hidden: !isAuthorized([RoleName.ROLE_ADMIN, RoleName.ROLE_ADMIN]),
  //   children: [
  //     {
  //       id: 'year',
  //       title: 'Année',
  //       type: 'item',
  //       icon: 'circle',
  //       url: 'pages/parametre/annee'
  //     }
  //   ]
  // },

  //============================================================================
  //==========================SOMMAVI===========================================
  //============================================================================

  // {
  //   id: "gestions",
  //   hidden: !isAuthorized2([RoleName.ROLE_ADMIN]),
  //   title: "Structure",
  //   type: "item",
  //   icon: "layout",
  //   children: [],
  // },

  // {
  //   id: 'apps',
  //   type: 'section',
  //   title: 'Notification',
  //   icon: 'package',
  //   children: [
  //     {
  //       id: 'home',
  //       title: 'Notification',
  //       type: 'item',
  //       icon: 'bell',
  //       url: '#'
  //     }
  //   ]
  // },
];
}

export const menu: CoreMenu[] = construireMenu();
